import {E} from "js-vextensions";
import {observer_mgl} from "mobx-graphlink";
import React from "react";
import {Column, DropDown, DropDownContent, DropDownTrigger} from "react-vcomponents";
import {BaseProps, BasicStyles} from "react-vextensions";
import {ScrollView} from "react-vscrollview";
import {GetEntities_WithUserTag, GetEntities_WithUserTags} from "../../Server/DB/entities.js";
import {Entity} from "../../Server/DB/entities/@Entity.js";
import {ES} from "web-vcore";

export type TexturePicker_Props = React.JSX.IntrinsicElements["div"] & BaseProps & React.PropsWithChildren & {
	value: string|n, onChange: (value: string|null)=>any,
	requiredEntityTags?: string[], // if specified, only show entities with (all) these tags; otherwise, show all entities with "texture" tag
	size?: number,
};

export const TexturePicker = observer_mgl((props: TexturePicker_Props)=>{
	const {value, onChange, style, children, size = 50, requiredEntityTags = ["texture"], ...rest} = props;
	//const textureEntities_suggestedTag = GetEntities().filter(a=>a.image_embedded != null && a.tags?.includes("texture"));
	const textureEntities = GetEntities_WithUserTags.CatchBail([] as Entity[], requiredEntityTags).filter(a=>a.image_embedded != null);
	const selectedTextureEntity = textureEntities.find(a=>a.id == value);

	const dropDown = React.useRef<DropDown|null>(null);

	return (
		<DropDown ref={dropDown} /*style={{flex: 1}}*/>
			<DropDownTrigger>
				<TextureCell name={selectedTextureEntity?.name ?? "(none)"} texture={selectedTextureEntity?.image_embedded} size={size} style={E(
					BasicStyles(props),
					style,
				)}/>
			</DropDownTrigger>
			<DropDownContent style={{left: 0, padding: null, background: null, borderRadius: null, zIndex: 1}}>
				<Column style={{width: 400, background: "black"}}>
					<ScrollView style={ES({flex: 1})} contentStyle={{position: "relative", maxHeight: 500, display: "flex", flexWrap: "wrap"}}>
						<TextureCell name="Remote texture" texture={null} size={size} onClick={()=>{
							onChange(null);
							dropDown.current?.Hide();
						}}/>
						{textureEntities.map((entity, index)=>{
							const texture = entity.image_embedded!;
							return <TextureCell key={index} name={entity.name} texture={texture} size={size} onClick={()=>{
								onChange(entity.id);
								dropDown.current?.Hide();
							}}/>;
						})}
					</ScrollView>
				</Column>
			</DropDownContent>
		</DropDown>
	);
});

export const TextureCell = (props: {name: string, texture: string|n, size: number, style?: any, onClick?: ()=>any} & React.JSX.IntrinsicElements["div"])=>{
	const {name, texture, size, style, onClick, ...rest} = props;
	return (
		<div {...rest}
			title={name}
			style={E(
				{
					width: size, height: size, borderRadius: 5,
					backgroundSize: "cover",
					border: "1px solid rgba(255,255,255,.3)",
					cursor: onClick ? "pointer" : "default",
				},
				texture != null && {backgroundImage: `url(${texture})`},
				texture == null && {
					//background: "rgba(0,0,0,1)",
					// "transparency" pattern (checkerboard of light and dark gray)
					//background: `repeating-conic-gradient(#ccc 0% 25%, white 0% 50%) 50% / 20px 20px`,
					backgroundImage: `repeating-conic-gradient(#ccc 0% 25%, white 0% 50%)`,
					backgroundPosition: "50%",
					backgroundSize: "20px 20px",
				},
				style
			)}
			onClick={onClick}/>
	);
}